import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import ModalHeader from '../../../../../../Setup/Shared/ModalHeader';
import TextEditor from '../../../../../../../shared-components/TextEditor';
import { ServerRequestProtected } from '../../../../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../../../../utils/Enum';
import Loader from '../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../General/DeleteConfirmation';

const AddNewPsychoTherapy = ({ openPsychotherapyPopup, handleClosePsychotherapy, data,
    //  setData,
      ...props }) => {
    let PSYCHO_THERAPY_MODEL = {
        PsychotherapyNotes: data?.PsychotherapyNotes || "",
    }
    // let { IsEditAllowed } = props;
    const API_URL = enumUtil.controller.General
    const [ mainPsychoTherapyModel, setMainPsychoTherapyModel ] = useState(PSYCHO_THERAPY_MODEL);
    const [ psychoTherapySaveModel, setPsychoTherapySaveModel] = useState({});
    const [ isLoading, setIsLoading] = useState(false);
    const [ isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);

    const ThearpyName = () => {
        return (
            <p className="heading">Psychotherapy Note</p>
        )
    }
    const handleChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainPsychoTherapyModel };
        let saveModal = { ...psychoTherapySaveModel };
        modal[name] = value;
        setMainPsychoTherapyModel(modal);
        for (var property in PSYCHO_THERAPY_MODEL) {
        if (name === property) {
            saveModal[name] = value;
        }
        }
        setPsychoTherapySaveModel(saveModal);
    };
    
    const handleSave = (action) => {
        // if(!IsEditAllowed) return;
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.PsychotherapyNote,    
            "ID" : data?.PsychotherapyNoteID || "0",
            "Data" : {
                "ProviderID" : data?.ProviderID,
                "PatientID" :data?.PatientID,
                "PsychotherapyNotes" : psychoTherapySaveModel?.PsychotherapyNotes,
            }
        })
        .then((response) => {
            setIsLoading(false);
            // psychoTherapySaveModel?.PsychotherapyNotes && setData(prev => ({ ...prev, PsychotherapyNotes: psychoTherapySaveModel?.PsychotherapyNotes, PsychotherapyNoteID: response?.id  }))
            // props?.setIsRecordSaved?.(true);
            handleClosePsychotherapy(action);
        }).catch((error) => {
            setIsLoading(false);
        })
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        // setData({});
        handleClosePsychotherapy('Deleted');
    }
    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                Messsage= {true}
                TableName={enumUtil.enumAPITableName.PsychotherapyNote}
                ID={data?.PsychotherapyNoteID || "0"}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (data?.PsychotherapyNoteID) {
        DeletePopup = (
            <button
                className={
                    true
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
  return (
            <Modal show={openPsychotherapyPopup} onHide={handleClosePsychotherapy} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_Psychotherapy_Popup">
                <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                    <ModalHeader HeaderName={ThearpyName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={handleClosePsychotherapy} />
                    <div className="">
                        <p className="text ar-light-color">Notes</p>
                        <div className="mt-1">
                            <TextEditor
                                value={mainPsychoTherapyModel.PsychotherapyNotes}
                                setValue={(value) =>
                                    handleChange({
                                        target: { name: "PsychotherapyNotes", value },
                                    })}
                                placeholder={"Detail your psychotherapy note here..."}
                            />
                        </div>
                    </div>
                </Modal.Body>

                <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                    <button className='btn btn-outline  px-10 h-100 dark-clr ' onClick={handleClosePsychotherapy}>Cancel</button>
                    <div className="d-flex align-items-center gap-2">
                        <button className={`btn btn-outline  px-10 h-100 validate-color `} onClick={() => {
                            handleSave("Print");
                        }}>Save & Print</button>
                        <button className={`btn btn-validate px-10 h-100 `}  onClick={() =>handleSave('Saved')}>Save</button>
                    </div>
                </div>
            </Modal>
  )
}

export default AddNewPsychoTherapy